import { Expose, Type, Transform } from "class-transformer";
import { MasterMaterialModel } from "./master_material";
import { TechnicianModel } from "./technician";

export class EventPaymentModel {
  constructor() {
    this.beforeImgUrls = [];
    this.afterImgUrls = [];
    this.paymentType = "deposit";
    this.netAmount = 0;
    this.depositAmount = 0;
    this.receivedAmount = 0;
  }

  @Expose({ name: "beforeImgUrls" })
  beforeImgUrls: string[];

  @Expose({ name: "afterImgUrls" })
  afterImgUrls: string[];

  @Expose({ name: "paymentType" })
  paymentType: "full" | "deposit" | "cod" | string;

  @Expose({ name: "netAmount" })
  netAmount: number;

  @Expose({ name: "depositAmount" })
  depositAmount: number;

  @Expose({ name: "receivedAmount" })
  receivedAmount: number;

  @Expose({ name: "paymentAmount" })
  get paymentAmount(): number {
    return (Number(this.depositAmount) || 0) + (Number(this.receivedAmount) || 0);
  }

  @Expose({ name: "remainingAmount" })
  get remainingAmount(): number {
    return Math.max(0, (Number(this.netAmount) || 0) - this.paymentAmount);
  }
}

export class EventDetailModel {
  constructor() {
    this.eventId = 0;
    this.orderNumber = "";
    this.eventName = "";
    this.shiptoAddress = new ShipToAddressModel();
    this.shiptoName = "";
    this.shiptoDate = null;
    this.startInstallDate = null;
    this.endInstallDate = null;
    this.shiptoContact = "";
    this.customerName = "";
    this.customerContact = "";
    this.customerEmail = "";
    this.eventDate = null;
    this.techinicianCount = 0;
    this.eventStatusName = "";
    this.eventStatusGroup = 1;
    this.eventStatusCode = "";
    this.createEventBy = null;
    this.product = [];
    this.poppos = [];
    this.equipment = [];
    this.serving = [];
    this.requestAmountTechnician = 0;
    this.actualAmountTechnician = 0;
    this.requestPGAmount = 0;
    this.actualPGAmount = 0;
    this.detail = "";
    this.isEdit = true;
    
    this.isEditProduct = false;
    this.isEditPoppos = false;
    this.isEditEquip = false;
    this.isEditServing = false;
    this.isEditTechAmount = false;

    this.technicians = [];
    this.eventRole = "";
    this.customerEventId = 0;
    this.productSummary = 0;
    this.paymentType = "";
    this.depositAmount = 0;
    this.imgUrls = [];
    this.customerCode = null;
    this.payment = new EventPaymentModel();
    this.reason = "";

    Object.defineProperty(this, "isEditAddress", {
      get: () => {
        return this.isEdit && this.eventStatusCode === "2";
      },
      enumerable: true,
      configurable: true,
    });

    Object.defineProperty(this, "isEditDelivery", {
      get: () => {
        return this.isEdit && this.eventStatusCode === "2";
      },
      enumerable: true,
      configurable: true,
    });
  }

  @Expose({ name: "eventId" })
  eventId: number;

  @Expose({ name: "orderNumber" })
  orderNumber: string;

  @Expose({ name: "eventName" })
  eventName: string;

  @Expose({ name: "eventStatusCode" })
  eventStatusCode?: string;

  @Expose({ name: "shiptoAddress" })
  @Type(() => ShipToAddressModel)
  shiptoAddress: ShipToAddressModel;

  @Expose({ name: "shiptoName" })
  shiptoName: string;

  @Expose({ name: "shiptoDate" })
  @Transform(({ value }) => value || null)
  shiptoDate?: string | null;

  @Expose({ name: "startInstallDate" })
  @Transform(({ value }) => value || null)
  startInstallDate?: string | null;

  @Expose({ name: "endInstallDate" })
  @Transform(({ value }) => value || null)
  endInstallDate?: string | null;

  @Expose({ name: "shiptoContact" })
  shiptoContact: string;

  @Expose({ name: "customerName" })
  customerName: string;

  @Expose()
  customerContact: string;

  @Expose({ name: "customerEmail" })
  customerEmail: string;

  @Expose({ name: "eventDate" })
  @Transform(({ value }) => value || null)
  eventDate?: string | null;

  @Expose({ name: "techinicianCount" })
  techinicianCount: number;

  @Type(() => MasterMaterialModel)
  product: MasterMaterialModel[];

  @Expose({ name: "products" })
  @Type(() => MasterMaterialModel)
  products?: MasterMaterialModel[];

  @Type(() => MasterMaterialModel)
  poppos: MasterMaterialModel[];

  @Type(() => MasterMaterialModel)
  equipment: MasterMaterialModel[];

  @Type(() => MasterMaterialModel)
  serving: MasterMaterialModel[];

  @Type(() => TechnicianModel)
  technicians: TechnicianModel[];

  @Expose({ name: "requestAmountTechnician" })
  requestAmountTechnician: number;

  @Expose({ name: "actualAmountTechnician" })
  actualAmountTechnician: number;

  @Expose({ name: "requestPGAmount" })
  requestPGAmount: number;

  @Expose({ name: "actualPGAmount" })
  actualPGAmount: number;

  @Expose({ name: "detail" })
  detail: string;

  eventStatusName: string;
  eventStatusGroup: number;

  @Expose({ name: "createEventBy" })
  createEventBy?: string | null;



  isEdit: boolean;

  isEditProduct?: boolean;
  isEditPoppos?: boolean;
  isEditEquip?: boolean;
  isEditServing?: boolean;
  isEditTechAmount?: boolean;

  isEditAddress?: boolean;
  isEditDelivery?: boolean;

  @Expose({ name: "eventRole" })
  eventRole: string;

  @Expose({ name: "customerEventId" })
  customerEventId: number | null;

  @Expose({ name: "customerCode" })
  customerCode?: string | null;

  @Expose({ name: "payment" })
  @Type(() => EventPaymentModel)
  payment?: EventPaymentModel;

  @Expose({ name: "reason" })
  reason?: string;

  @Expose({ name: "productSummary" })
  productSummary?: number;

  @Expose({ name: "paymentType" })
  paymentType?: "full" | "deposit" | "cod" | string;

  @Expose({ name: "depositAmount" })
  depositAmount?: number;

  @Expose({ name: "imgUrls" })
  imgUrls?: string[];
}

export class AddressOptionModel {
  constructor() {
    this.text = "";
    this.value = "";
  }

  @Expose({ name: "text" })
  text: string;

  @Expose({ name: "value" })
  value: string;
}

export class ShipToAddressModel {
  constructor() {
    this.address = "";
    this.province = new AddressOptionModel();
    this.district = new AddressOptionModel();
    this.subdistrict = new AddressOptionModel();
    this.zipCode = new AddressOptionModel();
  }

  @Expose({ name: "address" })
  address: string;

  @Expose({ name: "province" })
  @Type(() => AddressOptionModel)
  province: AddressOptionModel;

  @Expose({ name: "district" })
  @Type(() => AddressOptionModel)
  district: AddressOptionModel;

  @Expose({ name: "subdistrict" })
  @Type(() => AddressOptionModel)
  subdistrict: AddressOptionModel;

  @Expose({ name: "zipCode" })
  @Type(() => AddressOptionModel)
  zipCode: AddressOptionModel;
}
